import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  id?: string;
  tone?: 'cream' | 'paper' | 'charcoal';
  className?: string;
  ariaLabel?: string;
}
const tones = {
  cream: 'bg-cream text-charcoal',
  paper: 'bg-paper text-charcoal paper-texture',
  charcoal: 'bg-charcoal text-cream'
};
export function Section({
  children,
  id,
  tone = 'cream',
  className,
  ariaLabel
}: SectionProps) {
  return <section id={id} aria-label={ariaLabel} className={['relative py-16 sm:py-20 lg:py-28', tones[tone], className].filter(Boolean).join(' ')} data-id="element-177" data-mp="cfespuw7kh8m">
      <div className="relative mx-auto w-full max-w-shell px-5 sm:px-8" data-id="element-178" data-mp="2pv9go4l2ld8">{children}</div>
    </section>;
}
interface EyebrowProps {
  children: React.ReactNode;
  tone?: 'gold' | 'cream';
}
export function Eyebrow({
  children,
  tone = 'gold'
}: EyebrowProps) {
  return <span className={['block font-sans text-overline font-semibold uppercase', tone === 'gold' ? 'text-gold-dark' : 'text-gold-light'].join(' ')} data-id="element-179" data-mp="vd7wezenov72">
      {children}
    </span>;
}
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  tone = 'dark',
  className
}: SectionHeadingProps) {
  return <div className={[align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl', className].filter(Boolean).join(' ')} data-id="element-180" data-mp="3iajuhkqarlw2">
      {eyebrow ? <Eyebrow tone={tone === 'dark' ? 'gold' : 'cream'} data-id="element-181" data-mp="3rc9n2tvx0qvf">{eyebrow}</Eyebrow> : null}
      <h2 className={['font-serif text-h2', eyebrow ? 'mt-4' : '', tone === 'dark' ? 'text-charcoal' : 'text-cream'].join(' ')} data-id="element-182" data-mp="3na68hwdy965x">
        {title}
      </h2>
      {description ? <p className={['mt-4 text-[1.0625rem] leading-relaxed', tone === 'dark' ? 'text-charcoal-600' : 'text-cream/70'].join(' ')} data-id="element-183" data-mp="1sx6ozs6g7rtd">
          {description}
        </p> : null}
    </div>;
}